export default "__VITE_ASSET__I$67$uEG__"